<template>
  <div class="search_nav">
      <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="配置名称：">
              <el-input v-model="formInline.configName" placeholder="配置名称"></el-input>
          </el-form-item>
          <el-form-item label="协议类型：">
              <el-select style="width: 200px;" v-model="formInline.protocolType" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="中电联互联互通协议" :value="1"></el-option>
                  <el-option label="自用扩展协议" :value="2"></el-option>
                  <el-option label="深圳地标T77-2020" :value="3"></el-option>
                  <el-option label="深圳交委安监平台协议" :value="4"></el-option>
                  <el-option label="羊城充平台协议" :value="5"></el-option>
                  <el-option label="粤易充平台协议" :value="6"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="配置状态：">
              <el-select style="width: 120px;" v-model="formInline.configState" placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="正常" :value="1"></el-option>
                  <el-option label="禁用" :value="2"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item>
              <div class="button_group">
                  <el-button type="primary" @click="addConfig">新增配置</el-button>
                  <el-button type="primary" @click="getList">搜索</el-button>
                  <el-button type="primary" @click="refresh">刷新</el-button>
              </div>
          </el-form-item>
      </el-form>
  </div>

  <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="配置名称" width="150" show-overflow-tooltip>
          <template #default="scope">
              <span>{{ scope.row.configName || '-' }}</span>
          </template>
      </el-table-column>
      <el-table-column label="协议类型" width="220">
          <template #default="scope">
              <span>{{ protocolTypeFormat(scope.row.protocolType) }}</span>
          </template>
      </el-table-column>
      <el-table-column label="社会信用代码">
          <template #default="scope">
              <span>{{ scope.row.operatorId || '-' }}</span>
          </template>
      </el-table-column>
      <el-table-column label="己方运营商ID">
          <template #default="scope">
              <span>{{ scope.row.ownOperatorId || '-' }}</span>
          </template>
      </el-table-column>
      <el-table-column label="签名方式" width="100">
          <template #default="scope">
              <span>{{ scope.row.signType == 1 ? '标准' : '自定义' }}</span>
          </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180">
          <template #default="scope">
              <span>{{ scope.row.createTime || '-' }}</span>
          </template>
      </el-table-column>
      <el-table-column label="配置状态" width="100" fixed="right">
          <template #default="scope">
              <el-switch
                  v-model="scope.row.configState"
                  :active-value="1"
                  :inactive-value="2"
                  @change="toggleStatus(scope.row)"
              />
          </template>
      </el-table-column>
      <el-table-column label="操作" width="250" fixed="right">
          <template #default="scope">
              <el-button type="text" @click="viewDetail(scope.row)">详情</el-button>
              <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" @click="deleteConfig(scope.row)">删除</el-button>
              <el-button type="text" @click="bindStation(scope.row)">绑定场站</el-button>
          </template>
      </el-table-column>
  </el-table>

  <!-- 分页 -->
  <Pagination
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
  />

  <!-- 新增/编辑配置弹窗 -->
  <el-dialog v-model="showModal" :title="isEdit ? '编辑配置' : '新增配置'" :close-on-click-modal="false" width="800px" @closed="$refs.configFormRef?.clearValidate()">
      <el-form :model="configForm" :rules="configRules" ref="configFormRef" label-width="140px">
          <el-form-item label="配置名称" prop="configName">
              <el-input v-model="configForm.configName" maxlength="50" placeholder="请输入配置名称" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="合作方" prop="partnerId">
              <el-select v-model="configForm.partnerId" placeholder="请选择合作方" style="width: 100%;">
                  <el-option
                      v-for="item in partnerOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="协议类型" prop="protocolType">
              <el-select v-model="configForm.protocolType" placeholder="请选择">
                  <el-option label="中电联互联互通协议" :value="1"></el-option>
                  <el-option label="自用扩展协议" :value="2"></el-option>
                  <el-option label="深圳地标T77-2020" :value="3"></el-option>
                  <el-option label="深圳交委安监平台协议" :value="4"></el-option>
                  <el-option label="羊城充平台协议" :value="5"></el-option>
                  <el-option label="粤易充平台协议" :value="6"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="签名方式" prop="signType">
              <el-radio-group v-model="configForm.signType">
                  <el-radio :label="1">标准</el-radio>
                  <el-radio :label="2">自定义</el-radio>
              </el-radio-group>
          </el-form-item>
          
          <el-divider content-position="left">对方信息</el-divider>
          <el-form-item label="社会信用代码" prop="operatorId">
              <el-input v-model="configForm.operatorId" placeholder="请输入社会信用代码" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="对方URL地址" prop="apiUrl">
              <el-input v-model="configForm.apiUrl" placeholder="请输入对方URL地址" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="对方运营商密钥" prop="operatorSecret">
              <el-input v-model="configForm.operatorSecret" placeholder="请输入对方运营商密钥" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="对方签名密钥" prop="signSecret">
              <el-input v-model="configForm.signSecret" placeholder="请输入对方签名密钥"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="对方消息密钥" prop="dataSecret">
              <el-input v-model="configForm.dataSecret" placeholder="请输入对方消息密钥"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="对方初始化向量" prop="dataSecretIv">
              <el-input v-model="configForm.dataSecretIv" placeholder="请输入对方初始化向量"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="对方访问令牌" prop="accessToken">
              <el-input v-model="configForm.accessToken" placeholder="请输入对方访问令牌" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="对方令牌失效时间" prop="tokenExpiration">
              <el-date-picker
                  v-model="configForm.tokenExpiration"
                  type="datetime"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择对方令牌失效时间"
                  style="width: 100%;"
              />
          </el-form-item>
          
          <el-divider content-position="left">己方信息</el-divider>
          <el-form-item label="己方运营商ID" prop="ownOperatorId">
              <el-input v-model="configForm.ownOperatorId" placeholder="请输入己方运营商ID" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="己方URL地址" prop="ownApiUrl">
              <el-input v-model="configForm.ownApiUrl" placeholder="请输入己方URL地址" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="己方运营商密钥" prop="ownOperatorSecret">
              <el-input v-model="configForm.ownOperatorSecret" placeholder="请输入己方运营商密钥"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="己方签名密钥" prop="ownSignSecret">
              <el-input v-model="configForm.ownSignSecret" placeholder="请输入己方签名密钥"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="己方消息密钥" prop="ownDataSecret">
              <el-input v-model="configForm.ownDataSecret" placeholder="请输入己方消息密钥"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="己方初始化向量" prop="ownDataSecretIv">
              <el-input v-model="configForm.ownDataSecretIv" placeholder="请输入己方初始化向量"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="己方访问令牌" prop="ownAccessToken">
              <el-input v-model="configForm.ownAccessToken" placeholder="请输入己方访问令牌" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="己方令牌失效时间" prop="ownTokenExpiration">
              <el-date-picker
                  v-model="configForm.ownTokenExpiration"
                  type="datetime"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择己方令牌失效时间"
                  style="width: 100%;"
              />
          </el-form-item>
      </el-form>
      <template #footer>
          <el-button @click="showModal = false">取消</el-button>
          <el-button type="primary" @click="saveConfig">保存</el-button>
      </template>
  </el-dialog>

  <!-- 详情弹窗 -->
  <el-dialog v-model="showDetail" title="配置详情" width="800px">
      <div class="detail-content">
          <div class="detail-row">
              <span class="label">配置名称：</span>
              <span class="value">{{ detailData.configName || '-' }}</span>
          </div>
          <div class="detail-row">
              <span class="label">协议类型：</span>
              <span class="value">{{ protocolTypeFormat(detailData.protocolType) }}</span>
          </div>
          <div class="detail-row">
              <span class="label">签名方式：</span>
              <span class="value">{{ detailData.signType == 1 ? '标准' : '自定义' }}</span>
          </div>
          <div class="detail-row">
              <span class="label">配置状态：</span>
              <span class="value">{{ detailData.configState == 1 ? '正常' : '禁用' }}</span>
          </div>
          
          <el-divider content-position="left">对方信息</el-divider>
          <div class="detail-row">
              <span class="label">社会信用代码：</span>
              <span class="value">{{ detailData.operatorId || '-' }}</span>
          </div>
          <div class="detail-row">
              <span class="label">对方URL地址：</span>
              <span class="value">{{ detailData.apiUrl || '-' }}</span>
          </div>
          <div class="detail-row">
              <span class="label">对方访问令牌：</span>
              <span class="value">{{ detailData.accessToken || '-' }}</span>
          </div>
          <div class="detail-row">
              <span class="label">对方令牌失效时间：</span>
              <span class="value">{{ detailData.tokenExpiration || '-' }}</span>
          </div>
          
          <el-divider content-position="left">己方信息</el-divider>
          <div class="detail-row">
              <span class="label">己方运营商ID：</span>
              <span class="value">{{ detailData.ownOperatorId || '-' }}</span>
          </div>
          <div class="detail-row">
              <span class="label">己方URL地址：</span>
              <span class="value">{{ detailData.ownApiUrl || '-' }}</span>
          </div>
          <div class="detail-row">
              <span class="label">己方访问令牌：</span>
              <span class="value">{{ detailData.ownAccessToken || '-' }}</span>
          </div>
          <div class="detail-row">
              <span class="label">己方令牌失效时间：</span>
              <span class="value">{{ detailData.ownTokenExpiration || '-' }}</span>
          </div>
          
          <div class="detail-row">
              <span class="label">创建时间：</span>
              <span class="value">{{ detailData.createTime || '-' }}</span>
          </div>
      </div>
  </el-dialog>

  <!-- 绑定场站弹窗 -->
  <el-dialog v-model="showBindStationModal" title="绑定场站" :close-on-click-modal="false" width="600px">
      <div class="bind-station-content">
          <el-form :model="bindStationForm" label-width="100px">
              <el-form-item label="选择场站">
                  <el-select 
                      v-model="bindStationForm.stationIds" 
                      multiple 
                      clearable
                      collapse-tags
                      collapse-tags-tooltip
                      filterable 
                      placeholder="请选择场站"
                      style="width: 100%;"
                  >
                      <el-option
                          v-for="item in stationOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                      >
                      </el-option>
                  </el-select>
              </el-form-item>
          </el-form>
          <div class="selected-stations" v-if="bindStationForm.stationIds.length > 0">
              <span class="label">已选场站：</span>
              <el-tag
                  v-for="id in bindStationForm.stationIds"
                  :key="id"
                  closable
                  @close="removeStation(id)"
                  style="margin: 5px;"
              >
                  {{ getStationName(id) }}
              </el-tag>
          </div>
      </div>
      <template #footer>
          <el-button @click="showBindStationModal = false">取消</el-button>
          <el-button type="primary" @click="confirmBindStation">确认绑定</el-button>
      </template>
  </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import { required, maxLength, isCreditCode, isUrl, isAlphanumeric } from '@/utils/validators';

export default {
  name: 'HlhtConfig',
  data() {
      return {
          tableData: [],
          total: 0,
          currentPage: 1,
          pageSize: 10,
          showModal: false,
          showDetail: false,
          showBindStationModal: false,
          isEdit: false,
          detailData: {},
          stationOptions: [],
          partnerOptions: [],
          currentConfigId: '',
          bindStationForm: {
              stationIds: []
          },
          formInline: {
              configName: '',
              protocolType: '',
              configState: ''
          },
          configForm: {
              id: '',
              partnerId: '',
              configName: '',
              protocolType: '',
              configState: 1,
              signType: 1,
              operatorId: '',
              apiUrl: '',
              operatorSecret: '',
              signSecret: '',
              dataSecret: '',
              dataSecretIv: '',
              accessToken: '',
              tokenExpiration: '',
              ownOperatorId: '',
              ownApiUrl: '',
              ownOperatorSecret: '',
              ownSignSecret: '',
              ownDataSecret: '',
              ownDataSecretIv: '',
              ownAccessToken: '',
              ownTokenExpiration: ''
          },
          configRules: {
              partnerId: [required('请选择合作方')],
              configName: [required('请输入配置名称'), maxLength(50, '最多输入50个字符')],
              protocolType: [required('请选择协议类型')],
              signType: [required('请选择签名方式')],
              operatorId: [required('请输入社会信用代码'), isCreditCode()],
              apiUrl: [required('请输入对方URL地址'), isUrl()],
              operatorSecret: [required('请输入对方运营商密钥'), isAlphanumeric('对方运营商密钥只能包含字母和数字')],
              signSecret: [required('请输入对方签名密钥'), isAlphanumeric('对方签名密钥只能包含字母和数字')],
              dataSecret: [required('请输入对方消息密钥'), isAlphanumeric('对方消息密钥只能包含字母和数字')],
              dataSecretIv: [required('请输入对方初始化向量'), isAlphanumeric('对方初始化向量只能包含字母和数字')],
              ownOperatorId: [required('请输入己方运营商ID'), isAlphanumeric('己方运营商ID只能包含字母和数字')],
              ownApiUrl: [required('请输入己方URL地址'), isUrl()],
              ownOperatorSecret: [required('请输入己方运营商密钥'), isAlphanumeric('己方运营商密钥只能包含字母和数字')],
              ownSignSecret: [required('请输入己方签名密钥'), isAlphanumeric('己方签名密钥只能包含字母和数字')],
              ownDataSecret: [required('请输入己方消息密钥'), isAlphanumeric('己方消息密钥只能包含字母和数字')],
              ownDataSecretIv: [required('请输入己方初始化向量'), isAlphanumeric('己方初始化向量只能包含字母和数字')]
          }
      }
  },
  mounted() {
      this.getList();
      this.getStationOptions();
      this.getPartnerOptions();
  },
  watch: {
      '$store.state.stationList': {
          handler(newVal) {
              if (newVal && newVal.length > 0) {
                  this.stationOptions = newVal;
              }
          },
          immediate: true
      }
  },
  methods: {
      getStationOptions() {
          this.stationOptions = this.$store.state.stationList || [];
      },
      getPartnerOptions() {
          this.$axios.post(this.$store.state.platformApi + "partner/list", {}).then(result => {
              if (result.code == 200) {
                  this.partnerOptions = result.data || [];
              }
          });
      },
      getList() {
          let param = {
              page: this.currentPage,
              pageSize: this.pageSize
          };
          Object.keys(this.formInline).forEach(key => {
              if (this.formInline[key]) {
                  param[key] = this.formInline[key];
              }
          });
          this.$axios.post(this.$store.state.platformApi + "hlht/config/page", JSON.stringify(param)).then(result => {
              if (result.code == 200) {
                  this.tableData = result.data.records;
                  this.total = result.data.total;
              }
          });
      },
      handleSizeChange(val) {
          this.pageSize = val;
          this.getList();
      },
      handleCurrentChange(val) {
          this.currentPage = val;
          this.getList();
      },
      refresh() {
          this.formInline = {
              configName: '',
              protocolType: '',
              configState: ''
          };
          this.currentPage = 1;
          this.getList();
      },
      protocolTypeFormat(value) {
          const typeMap = {
              1: '中电联互联互通协议',
              2: '自用扩展协议',
              3: '深圳地标T77-2020',
              4: '深圳交委安监平台协议',
              5: '羊城充平台协议',
              6: '粤易充平台协议'
          };
          return typeMap[value] || '-';
      },
      addConfig() {
          this.isEdit = false;
          this.configForm = {
              id: '',
              partnerId: '',
              configName: '',
              protocolType: '',
              configState: 1,
              signType: 1,
              operatorId: '',
              apiUrl: '',
              operatorSecret: '',
              signSecret: '',
              dataSecret: '',
              dataSecretIv: '',
              accessToken: '',
              tokenExpiration: '',
              ownOperatorId: '',
              ownApiUrl: '',
              ownOperatorSecret: '',
              ownSignSecret: '',
              ownDataSecret: '',
              ownDataSecretIv: '',
              ownAccessToken: '',
              ownTokenExpiration: ''
          };
          this.showModal = true;
      },
      handleEdit(row) {
          this.isEdit = true;
          this.configForm = { ...row };
          this.showModal = true;
      },
      saveConfig() {
          this.$refs.configFormRef.validate((valid) => {
              if (!valid) return;
              let url = this.isEdit 
                  ? this.$store.state.platformApi + "hlht/config/edit"
                  : this.$store.state.platformApi + "hlht/config/add";
              this.$axios.post(url, JSON.stringify(this.configForm)).then(result => {
                  if (result.code == 200) {
                      ElMessage.success(this.isEdit ? '修改成功' : '新增成功');
                      this.showModal = false;
                      this.getList();
                  }
              });
          });
      },
      viewDetail(row) {
          this.detailData = row;
          this.showDetail = true;
      },
      deleteConfig(row) {
          this.$confirm('确认删除该配置吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.$axios.post(this.$store.state.platformApi + "hlht/config/delete/" + row.id, {}).then(result => {
                  if (result.code == 200) {
                      ElMessage.success('删除成功');
                      this.getList();
                  }
              });
          }).catch(() => {});
      },
      toggleStatus(row) {
          let param = {
              id: row.id,
              configState: row.configState
          };
          this.$axios.post(this.$store.state.platformApi + "hlht/config/configState", JSON.stringify(param)).then(result => {
              if (result.code == 200) {
                  ElMessage.success('状态更新成功');
              } else {
                  row.configState = row.configState == 1 ? 2 : 1;
              }
          });
      },
      bindStation(row) {
          this.currentConfigId = row.id;
          // 从 hlhtConfigStationVos 数组中提取 stationId 赋值给 stationIds
          this.bindStationForm.stationIds = row.hlhtConfigStationVos ? row.hlhtConfigStationVos.map(item => item.stationId) : [];
          this.showBindStationModal = true;
      },
      confirmBindStation() {
          if (this.bindStationForm.stationIds.length === 0) {
              ElMessage.warning('请至少选择一个场站');
              return;
          }
          // 将 stationIds 数组转换为 stations 对象，key 是场站 id，value 是场站名称
          const stations = {};
          this.bindStationForm.stationIds.forEach(id => {
              const station = this.stationOptions.find(item => item.id === id);
              if (station) {
                  stations[id] = station.name;
              }
          });
          
          let param = {
              configId: this.currentConfigId,
              stations: stations
          };
          this.$axios.post(this.$store.state.platformApi + "hlht/config/bindStation", JSON.stringify(param)).then(result => {
              if (result.code == 200) {
                  ElMessage.success('绑定成功');
                  this.showBindStationModal = false;
                  this.getList();
              }
          });
      },
      removeStation(id) {
          this.bindStationForm.stationIds = this.bindStationForm.stationIds.filter(item => item !== id);
      },
      getStationName(id) {
          const station = this.stationOptions.find(item => item.id === id);
          return station ? station.name : id;
      }
  }
}
</script>

<style lang="scss" scoped>
.search_nav {
  width: 100%;
  margin-bottom: 20px;
}

.detail-content {
  .detail-row {
      margin-bottom: 15px;
      display: flex;
      
      .label {
          width: 140px;
          text-align: right;
          color: #606266;
          font-weight: 500;
      }
      
      .value {
          flex: 1;
          color: #303133;
      }
  }
}

.bind-station-content {
  .selected-stations {
      margin-top: 10px;
      padding: 10px;
      background-color: #f5f7fa;
      border-radius: 4px;
      
      .label {
          display: block;
          margin-bottom: 8px;
          color: #606266;
          font-weight: 500;
      }
  }
}
</style>